import getFirebase from "../../../firebase";
import {appState} from "../../../globalState";
import {collection, getDocs, getFirestore, query} from "firebase/firestore";

export async function searchProposal() {
    const db = getFirestore(getFirebase());
    const q = query(collection(db, "my_tulu"));

    const myTuluDb = await getDocs(q);

    const ids = [];
    myTuluDb.forEach((snapshot) => {
        ids.push(snapshot.id);
    });
    appState.savedProposals = ids;
}
